import services from '@/services';
const PATH = '/purchases';
export default {
    async createCheckoutSession(sessionBody) {
        return await services.postAsync({
            url: PATH + '/checkouts',
            hasToken: true,
            body: sessionBody
        });
    },
    async getCheckoutSession(checkoutSessionId) {
        return await services.getAsync({
            url: PATH + '/checkouts/' + checkoutSessionId,
            hasToken: true
        });
    },
    async createCustomersPortalLink(return_url) {
        return await services.postAsync({
            url: PATH + '/portals',
            hasToken: true,
            body: { return_url }
        });
    }
}